<template>
  <div id="app">
    <global-nav></global-nav>
    <router-view></router-view>
  </div>
</template>

<script>
import "./styles/style.css";
import GlobalNav from "./components/GlobalNav";
export default {
  name: "app",
  components: {
    GlobalNav
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
pre {
  margin: 12px auto 0 auto;
  border: 1px solid #f8f8f8;
  background: #4b4b4b;
  color: white;
  font-size: 14px;
  padding: 10px 16px;
  line-height: 18px;
  border-radius: 4px;
  overflow: scroll;
  max-height: 700px;
  text-align: left;
}
.example {
  font-size: 16px;
  color: #333333;
  line-height: 20px;
  height: 20px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// App.vue?23d762fc